"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.separatorExpanded = exports.certificationIconStyle = exports.actionsMenuStyle = exports.minWidthClass = exports.vizPortalFontClass = exports.placeHeaderMetadataLinkClass = exports.linkClass = exports.placeHeaderMetadataLinkStyle = exports.linkStyle = exports.vizPortalLowDpiFontStyle = exports.vizPortalFontStyle = exports.placeHeaderTitleStyle = exports.MetadataLabelColor = exports.headerIconStyle = exports.headerIconContainerStyle = exports.nonPlaceTitleStyle = exports.spaceHeaderContentStyle = exports.headerPaddingStyle = exports.Grey218 = exports.AccessibleHyperLinkBlueFocus = exports.AccessibleHyperLinkBlueHover = exports.AccessibleHyperLinkBlue = exports.ListViewRowOuterHeight = void 0;
// Styles copied from VizportalClient
const widgets_1 = require("@tableau/widgets");
const LayoutStyles_1 = require("./LayoutStyles");
const StyleFunctions_1 = require("./StyleFunctions");
// Copied from vizportalclient, ExplorerStyles.ts
exports.ListViewRowOuterHeight = 44;
// From vizportalclient/src/app/spaces/SpacesStyles.ts
const headerIconSize = '60px';
const titleFontSize = '26px';
const titleRowHeight = '30px';
// from vizportalclient: src/styl/includes/colors.styl
exports.AccessibleHyperLinkBlue = '#1a699e';
exports.AccessibleHyperLinkBlueHover = '#2a79af';
exports.AccessibleHyperLinkBlueFocus = '#15557f';
exports.Grey218 = 'rgb(218,218,218)';
// From vizportalclient/src/app/spaces/Header/SpaceHeaderStyles.ts
exports.headerPaddingStyle = {
    paddingLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingTop: widgets_1.TabStyles.Spacing.LargeSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.MediumSpace,
};
// From SpaceHeaderContent in vizportalclient/src/app/spaces/Explorer/ExplorerStyles.ts
exports.spaceHeaderContentStyle = {
    marginTop: widgets_1.TabStyles.Spacing.MediumSpace,
    marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    height: 18,
};
exports.nonPlaceTitleStyle = {
    color: widgets_1.TabStyles.Typography.Color.Primary,
    fontSize: widgets_1.TabStyles.Typography.Sizing.XXLarge,
};
exports.headerIconContainerStyle = {
    position: 'relative',
    minWidth: headerIconSize,
    height: headerIconSize,
    marginRight: widgets_1.TabStyles.Spacing.MediumSpace,
};
exports.headerIconStyle = {
    position: 'absolute',
    top: '-5px',
    left: 0,
    width: headerIconSize,
    height: headerIconSize,
};
exports.MetadataLabelColor = {
    color: '#9B9B9B',
};
exports.placeHeaderTitleStyle = Object.assign(Object.assign({}, LayoutStyles_1.elideTextStyle), { color: widgets_1.TabStyles.Typography.Color.Primary, fontSize: titleFontSize, height: titleRowHeight, lineHeight: titleRowHeight, marginRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace });
exports.vizPortalFontStyle = {
    fontFamily: 'Benton Sans, Arial, Helvetica, sans-serif',
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    lineHeight: '1.5em',
};
// We shouldn't be using the low-DPI font, but some designers have specified it, so we're using it in some places
// in order for the DC3 visuals to match the main VizPortal visuals :-(
exports.vizPortalLowDpiFontStyle = Object.assign(Object.assign({}, exports.vizPortalFontStyle), { fontFamily: 'Benton Sans Low-DPI, Arial, Helvetica, sans-serif' });
exports.linkStyle = {
    color: exports.AccessibleHyperLinkBlue,
    textDecoration: 'none',
    outline: 0,
    cursor: 'pointer',
    $nest: {
        '&:hover': {
            textDecoration: 'underline',
            color: exports.AccessibleHyperLinkBlueHover,
        },
        '&:focus': {
            textDecoration: 'underline',
            color: exports.AccessibleHyperLinkBlueFocus,
        },
    },
};
exports.placeHeaderMetadataLinkStyle = Object.assign(Object.assign({}, exports.linkStyle), { color: '#4996B2' });
exports.linkClass = (0, StyleFunctions_1.cssClass)('link', exports.linkStyle);
exports.placeHeaderMetadataLinkClass = (0, StyleFunctions_1.cssClass)('placeHeaderMetadataLink', exports.placeHeaderMetadataLinkStyle);
exports.vizPortalFontClass = (0, StyleFunctions_1.cssClass)('VizPortalFont', exports.vizPortalFontStyle);
exports.minWidthClass = (0, StyleFunctions_1.cssClass)('MinWidth', {
    minWidth: 0,
});
exports.actionsMenuStyle = {
    height: titleRowHeight,
    lineHeight: titleRowHeight,
};
exports.certificationIconStyle = (0, StyleFunctions_1.cssClass)('certification-icon', {
    alignContent: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '16px',
    width: '16px',
    marginRight: widgets_1.TabStyles.Spacing.SmallSpace,
    marginLeft: widgets_1.TabStyles.Spacing.SmallSpace,
});
const separator = {
    height: 1,
    backgroundColor: widgets_1.TabStyles.Colors.L9Disabled,
    marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    marginTop: widgets_1.TabStyles.Spacing.MediumSpace,
};
exports.separatorExpanded = (0, StyleFunctions_1.cssClass)('separator-expanded', Object.assign(Object.assign({}, separator), { marginRight: widgets_1.TabStyles.Spacing.SmallSpace, marginLeft: widgets_1.TabStyles.Spacing.SmallSpace }));
//# sourceMappingURL=VizPortalStyles.js.map